import { CompetitionWhitelist } from './competition-whitelist'
import { Injectable } from '@angular/core'

@Injectable()
export class CompetitionWhitelistSerializer {
  fromJson(json: any): CompetitionWhitelist {
    const competitionWhitelist = {
      ...json
    }

    return competitionWhitelist
  }

  toJson(competitionWhitelist: CompetitionWhitelist): any {
    return {
      ...competitionWhitelist
    }
  }
}
